<template v-slot="main">
  <div class="modal-container">
    <div class="modal-header">
      <h2>{{ $t('transferred_modal.title') }}</h2>
    </div>

    <div class="modal-body">
      <p>{{ $t('transferred_modal.transfer_successfull') }}
         {{ skillLabel }}
      </p>
      <p>{{ $t('transferred_modal.now_in_waiting_section')}}</p>
    </div>

    <div class="modal-footer">
      <button v-on:click="closeModal" class="btn">
        {{ $t('Ok') }}
      </button>
    </div>
  </div>
</template>

<script>
import BaseModal from '@/layout/modals/BaseModal.vue'

export default {
  extends: BaseModal,
  name: 'TransferredRoomModal',
  computed: {
    room () {
      return this.$store.getters['rooms/getRoom']
    },
    settings () {
      return this.$settings
    },
    skillLabel () {
      if (this.$store.getters['global/getSkills'] &&
          this.$store.getters['global/getSkillByUuid'](this.room.skill)) {
        return this.$store.getters['global/getSkillByUuid'](this.room.skill).label
      }
      return null
    }
  },
  created () {
    this.$store.dispatch('global/sendGetSkills')
  }
}

</script>

<style lang="scss">
.modal-body {
  ul {
    list-style: none;
    display: flex;
    flex-direction: rows;
    flex-wrap: wrap;
    margin: 0;
    padding: 0;

    li {
      margin: 0;
      padding: 0;

      .btn {
        display: flex;
        flex-direction: column;

        p {
          opacity: .6;
        }
      }
    }
  }
}
</style>
